import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import updatePatient from '../../utils/patient/updatePatient';

const PatientEmailModal = ({ open, onClose, patient, onEmailSaved }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleEmailSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const updatedPatient = await updatePatient(patient.getUUID(), {
        email: values.email
      });
      toast.success(t('common.saved'));
      onClose();
      onEmailSaved(updatedPatient);
    } catch (error) {
      toast.error(t('patient_form.errors.save_failed'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      title={t('patient_form.add_email')}
      open={open}
      onCancel={onClose}
      footer={null}
      width={400}
    >
      <div style={{ marginTop: '20px' }}>
        <Form
          form={form}
          onFinish={handleEmailSubmit}
          layout="vertical"
          validateTrigger={['onBlur', 'onSubmit']}
          validateFirst
        >
          <Form.Item
            name="email"
            validateFirst
            rules={[
              { required: true, message: t('patient_form.errors.email_required') },
              {
                type: 'email',
                message: t('patient_form.errors.invalid_email'),
              }
            ]}
          >
            <Input 
              type="email" 
              style={{ fontSize: '16px' }}
              placeholder={t('patient_form.fields.email_placeholder')}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 10 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={isSubmitting}
              block
            >
              {t('common.save')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default PatientEmailModal; 